import { render, staticRenderFns } from "./formCreator.vue?vue&type=template&id=04e0269a&"
import script from "./formCreator.vue?vue&type=script&lang=js&"
export * from "./formCreator.vue?vue&type=script&lang=js&"
import style0 from "./formCreator.vue?vue&type=style&index=0&id=04e0269a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports